var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ClassNames } from '@emotion/react';
import { useState, useCallback, useRef, } from 'react';
import { CSSTransition } from 'react-transition-group';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
const FadeReveal = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [height, setHeight,] = useState(0);
    const wrapper = useRef(null);
    const updateHeight = useCallback(() => {
        if (wrapper.current
            && wrapper.current.scrollHeight) {
            setHeight(styleUtils.rem(wrapper.current.scrollHeight));
        }
    }, []);
    return (_jsx(ClassNames, { children: ({ css, }) => (_jsx(CSSTransition, Object.assign({}, props, { appear: true, classNames: {
                enter: css `
                  height: 0;
                  opacity: 0;
                  overflow: hidden;
                `,
                enterActive: css `
                  height: ${height};
                  opacity: 1;
                  ${styleUtils.transition('all')}
                `,
                exit: css `
                  height: ${height};
                  opacity: 1;
                `,
                exitActive: css `
                  height: 0 !important; /* stylelint-disable-line declaration-no-important */
                  opacity: 1;
                  overflow: hidden;
                  ${styleUtils.transition('all')}
                `,
            }, onEnter: updateHeight, onExit: updateHeight, timeout: parseInt(theme.durationDefault, 10) }, { children: _jsx("div", Object.assign({ ref: wrapper }, { children: children })) }))) }));
};
export { FadeReveal };
